import { h } from 'preact'

interface Props {
  replyCount: number
}

const TopicReplyCount = ({ replyCount } : Props) => (
  <span class='topic__reply-count'>
    <i class='thread-meta-item__icon icon--comment icon--auto-width' />
    <span class='thread-meta-item__text'>
      {replyCount}
    </span>
  </span>
)

export default TopicReplyCount
